import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import { mutator } from 'satcheljs';
import {
    hideCustomRecurrenceForm,
    updateCustomRecurrenceFormRecurrenceType,
    updateCustomRecurrenceFormStartDate,
} from 'owa-calendar-compose-form-actions';

export let hideCustomRecurrenceFormMutator = mutator(hideCustomRecurrenceForm, actionMessage => {
    let fullComposeViewState = getFullComposeViewState(actionMessage.formId);
    if (!fullComposeViewState) {
        return;
    }

    fullComposeViewState.customRecurrenceViewState.recurrence = null;
    fullComposeViewState.customRecurrenceViewState.startDate = null;
});

export let updateCustomRecurrenceFormRecurrenceTypeMutator = mutator(
    updateCustomRecurrenceFormRecurrenceType,
    actionMessage => {
        let fullComposeViewState = getFullComposeViewState(actionMessage.formId);

        if (!fullComposeViewState) {
            return;
        }

        fullComposeViewState.customRecurrenceViewState.recurrence = actionMessage.recurrence;
    }
);

export let updateCustomRecurrenceFormStartDateMutator = mutator(
    updateCustomRecurrenceFormStartDate,
    actionMessage => {
        let fullComposeViewState = getFullComposeViewState(actionMessage.formId);

        if (!fullComposeViewState) {
            return;
        }

        fullComposeViewState.customRecurrenceViewState.startDate = actionMessage.startDate;
    }
);
